import dayjs from 'dayjs';
export var getNumberRangeArray = function (start, end) {
    return new Array(end - start + 1).fill(0).map(function (_, i) { return i + start; });
};
export var getAgeGroupFromDOB = function (dateOfBirth, isDependent) {
    var dob = dayjs(dateOfBirth);
    var now = dayjs();
    var age = now.diff(dob, 'years');
    if (age <= 17) {
        return isDependent ? '18-25' : 'Child';
    }
    if (age >= 18 && age <= 25) {
        return '18-25';
    }
    if (age >= 26 && age <= 29) {
        return '26-29';
    }
    if (age >= 30 && age <= 34) {
        return '30-34';
    }
    if (age >= 35 && age <= 39) {
        return '35-39';
    }
    if (age >= 40 && age <= 44) {
        return '40-44';
    }
    if (age >= 45 && age <= 49) {
        return '45-49';
    }
    if (age >= 50 && age <= 54) {
        return '50-54';
    }
    if (age >= 55 && age <= 59) {
        return '55-59';
    }
    if (age >= 60 && age <= 64) {
        return '60-64';
    }
    if (age >= 65 && age <= 69) {
        return '65-69';
    }
    if (age >= 70 && age <= 74) {
        return '70-74';
    }
    if (age >= 75 && age <= 79) {
        return '75-79';
    }
    return '80+';
};
